import CategoryMenu from 'common/components/category-menu';
import { renderIntoElement } from 'common/components/utils';

function initCategoryMenu(data) {
  const wrapper = document.querySelector('.js-category-menu');

  wrapper && renderIntoElement(CategoryMenu, wrapper, { categories: data.categories });
}

export default initCategoryMenu;
